import React, { ReactNode, useEffect, useRef } from 'react';
import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { Navigation, Pagination, Mousewheel, Autoplay } from 'swiper/modules';

// import styles bundle
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

interface SwiperComponentProps {
	options: SwiperOptions;
	children: ReactNode;
}

export const SwiperComponent: React.FC<SwiperComponentProps> = ({ children, options }) => {
	const swiperContainerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const swiperContainer = swiperContainerRef.current;
		if (!swiperContainer) return;

		const swiper = new Swiper(swiperContainer, {
			...{
				modules: [Pagination, Mousewheel, Autoplay],
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				...options,
			},
		});
		return () => swiper.destroy();
	}, [options, swiperContainerRef.current]);

	return (
		<>
			<div ref={swiperContainerRef} className="swiper-container relative isolate">
				<div className="swiper-wrapper">
					{React.Children.map(children, (child, index) => (
						<div key={index} className="swiper-slide !h-auto">
							{child}
						</div>
					))}
				</div>
				{typeof options?.pagination === 'object' ? null : (
					<div className="swiper-pagination dark:[&_.swiper-pagination-bullet]:!bg-white !relative pt-2"></div>
				)}
			</div>
		</>
	);
};
